import React from 'react';

const DownloadModal = ({ isOpen, onClose, onDownload }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2>Descargar Leads</h2>
                <p>¿Estás seguro de que quieres descargar los leads en formato CSV?</p>
                <div className="modal-actions">
                    <button className="btn-secondary" onClick={onClose}>Cancelar</button>
                    <button className="btn-primary" onClick={onDownload}>Descargar</button>
                </div>
            </div>
        </div>
    );
};

export default DownloadModal;